module.exports = __webpack_public_path__ + "static/media/buscas-anunciarte.efdf3d73.png";